import React, { useState, useEffect } from "react";
import { Table, Container, Input, Row, Col, Button } from 'reactstrap';
import './ProposalStyle.css';
import "./Reports.css";
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function Report58Component() {

    const currentYearTh = new Date().getFullYear() + 543;

    const [startBudgetYear, setStartBudgetYear] = useState(currentYearTh);
    const [endBudgetYear, setEndBudgetYear] = useState(currentYearTh);

    const [reportData, setReportData] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);

    const [loading, setLoading] = useState(false);

    /* =========================
      FETCH SUMMARY
    ========================== */
    async function fetchReport58() {
        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("startBudgetYear", startBudgetYear);
            formData.append("endBudgetYear", endBudgetYear);

            const res = await fetch("/api/SupportReports/dataReport58", {
                method: "POST",
                body: formData
            });

            const json = await res.json();
            setReportData(json.dataenum || []);
        }
        finally {
            setLoading(false);
        }
    }

    async function fetchYearOptions() {
        const res = await fetch("/api/Support/getyear57");
        const json = await res.json();
        setYearOptions(json.dataenum || []);
    }

    useEffect(() => {
        fetchReport58();
        fetchYearOptions();
    }, [startBudgetYear, endBudgetYear]);

    const budgetYears = [];
    for (let y = Number(startBudgetYear); y <= Number(endBudgetYear); y++) {
        budgetYears.push(y);
    }

    /* =========================
       CALCULATE TOTALS
    ========================== */

    const rowTotals = reportData.map(row =>
        row.detailBudgetYear?.reduce((sum, y) => sum + (y.amount || 0), 0) || 0
    );

    const grandTotal = rowTotals.reduce((sum, v) => sum + v, 0);

    const yearTotals = budgetYears.map((year, index) => {
        let totalSupport = 0;
        let totalPerson = 0;
        let totalAmount = 0;

        reportData.forEach(row => {
            const data = row.detailBudgetYear?.[index];
            if (data) {
                totalSupport += data.supportAmount || 0;
                totalPerson += data.personAmount || 0;
                totalAmount += data.amount || 0;
            }
        });

        return { totalSupport, totalPerson, totalAmount };
    });

    /* =========================
       EXPORT EXCEL
    ========================== */

    const exportExcel = () => {

        const wb = XLSX.utils.book_new();
        const wsData = [];

        const header1 = ["ลำดับ", "รายการ"];
        const header2 = ["", ""];
        const header3 = ["", ""];

        // ชั้นบน
        header1.push("อนุมัติเงินอุดหนุน");
        for (let y = 1; y < budgetYears.length * 3; y++) {
            header1.push("");
        }

        header1.push("ร้อยละ");

        // ชั้นปี
        budgetYears.forEach(year => {
            header2.push(`ปีงบประมาณ ${year}`, "", "");
        });

        header2.push("");

        // ชั้นหน่วย
        budgetYears.forEach(() => {
            header3.push("(แห่ง)", "(คน)", "(บาท)");
        });

        header3.push("");

        wsData.push(header1);
        wsData.push(header2);
        wsData.push(header3);

        // ================= BODY =================
        reportData.forEach((row, i) => {

            const percent = grandTotal > 0
                ? ((rowTotals[i] / grandTotal) * 100).toFixed(2)
                : "0.00";

            const rowData = [
                i + 1,
                row.supportTypeName
            ];

            row.detailBudgetYear.forEach(d => {
                rowData.push(
                    d.supportAmount || 0,
                    d.personAmount || 0,
                    d.amount || 0
                );
            });

            rowData.push(percent + "%");

            wsData.push(rowData);
        });

        const ws = XLSX.utils.aoa_to_sheet(wsData);

        const merges = [];

        // merge ลำดับ
        merges.push({ s: { r: 0, c: 0 }, e: { r: 2, c: 0 } });
        merges.push({ s: { r: 0, c: 1 }, e: { r: 2, c: 1 } });

        // merge อนุมัติเงินอุดหนุน
        merges.push({
            s: { r: 0, c: 2 },
            e: { r: 0, c: 2 + (budgetYears.length * 3) - 1 }
        });

        // merge ร้อยละ
        merges.push({
            s: { r: 0, c: 2 + (budgetYears.length * 3) },
            e: { r: 2, c: 2 + (budgetYears.length * 3) }
        });

        let colIndex = 2;

        budgetYears.forEach(() => {
            merges.push({
                s: { r: 1, c: colIndex },
                e: { r: 1, c: colIndex + 2 }
            });
            colIndex += 3;
        });

        ws["!merges"] = merges;

        XLSX.utils.book_append_sheet(wb, ws, "Report58");
        XLSX.writeFile(wb, "Report58.xlsx");
    };

    /* =========================
       EXPORT PDF
    ========================== */
    function base64FromArrayBuffer(buf) {
        const bytes = new Uint8Array(buf);
        const chunkSize = 0x8000;
        let binary = "";
        for (let i = 0; i < bytes.length; i += chunkSize) {
            binary += String.fromCharCode.apply(
                null,
                bytes.subarray(i, i + chunkSize)
            );
        }
        return btoa(binary);
    }

    let thaiFontLoaded = false;

    async function ensureThaiFontLoaded() {
        if (thaiFontLoaded) return;

        const [regRes, boldRes] = await Promise.all([
            fetch("/fonts/Sarabun-Regular.ttf"),
            fetch("/fonts/Sarabun-Bold.ttf")
        ]);

        const [regBuf, boldBuf] = await Promise.all([
            regRes.arrayBuffer(),
            boldRes.arrayBuffer()
        ]);

        const regB64 = base64FromArrayBuffer(regBuf);
        const boldB64 = base64FromArrayBuffer(boldBuf);

        jsPDF.API.events.push([
            "addFonts",
            function () {
                this.addFileToVFS("Sarabun-Regular.ttf", regB64);
                this.addFileToVFS("Sarabun-Bold.ttf", boldB64);
                this.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");
                this.addFont("Sarabun-Bold.ttf", "Sarabun", "bold");
            }
        ]);

        new jsPDF();
        thaiFontLoaded = true;
    }

    const exportPDF = async () => {

        await ensureThaiFontLoaded();

        const doc = new jsPDF({
            orientation: "landscape",
            unit: "mm",
            format: "a3"
        });

        doc.setFont("Sarabun");

        const header1 = ["ลำดับ", "รายการ"];
        const header2 = ["", ""];
        const header3 = ["", ""];

        header1.push("อนุมัติเงินอุดหนุน");
        for (let y = 1; y < budgetYears.length * 3; y++) {
            header1.push("");
        }
        header1.push("ร้อยละ");

        budgetYears.forEach(year => {
            header2.push(`ปีงบประมาณ ${year}`, "", "");
        });
        header2.push("");

        budgetYears.forEach(() => {
            header3.push("(แห่ง)", "(คน)", "(บาท)");
        });
        header3.push("");

        const tableHead = [header1, header2, header3];

        const tableBody = [];

        reportData.forEach((row, i) => {

            const percent = grandTotal > 0
                ? ((rowTotals[i] / grandTotal) * 100).toFixed(2)
                : "0.00";

            const rowData = [
                i + 1,
                row.supportTypeName
            ];

            row.detailBudgetYear.forEach(d => {
                rowData.push(
                    d.supportAmount || 0,
                    d.personAmount || 0,
                    d.amount || 0
                );
            });

            rowData.push(percent + "%");

            tableBody.push(rowData);
        });

        autoTable(doc, {
            head: tableHead,
            body: tableBody,
            startY: 15,
            styles: {
                font: "Sarabun",
                fontSize: 8,
                cellPadding: 1
            },
            theme: "grid"
        });

        doc.save("Report58.pdf");
    };

    return (
        <Container>
            <div>

                {/* ===== FILTER ===== */}
                <Row className="mb-3 align-items-center">
                    <Col md={2}><h5>ปีงบประมาณ</h5></Col>

                    <Col md={3}>
                        <Input
                            type="select"
                            value={startBudgetYear}
                            disabled={loading}
                            onChange={e => setStartBudgetYear(e.target.value)}
                        >
                            {yearOptions.map(y => (
                                <option key={y.yearTh} value={y.yearTh}>
                                    {y.yearTh}
                                </option>
                            ))}
                        </Input>
                    </Col>

                    <Col md={1} className="text-center">ถึง</Col>

                    <Col md={3}>
                        <Input
                            type="select"
                            value={endBudgetYear}
                            disabled={loading}
                            onChange={e => setEndBudgetYear(e.target.value)}
                        >
                            {yearOptions
                                .filter(y => y.yearTh >= startBudgetYear)
                                .map(y => (
                                    <option key={y.yearTh} value={y.yearTh}>
                                        {y.yearTh}
                                    </option>
                                ))}
                        </Input>
                    </Col>

                    <Col md={3} className="text-end">
                        <Button
                            className="btn-export excel me-2"
                            onClick={exportExcel}
                            disabled={loading || !reportData.length}
                        >
                            Excel
                        </Button>
                        <Button
                            className="btn-export pdf"
                            onClick={exportPDF}
                            disabled={loading || !reportData.length}
                        >
                            PDF
                        </Button>
                    </Col>
                </Row>

                <div className="outer-wrapper">
                    <div className="table-wrapper">
                        <Table bordered hover responsive className="report-table" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr>
                                    <th rowSpan="3">ลำดับ</th>
                                    <th rowSpan="3" className='text-center'>รายการ</th>
                                    <th colSpan={budgetYears.length * 3} className='text-center'>
                                        อนุมัติเงินอุดหนุน
                                    </th>
                                    <th rowSpan={3} className="text-center bg-light">
                                        ร้อยละของสัดส่วนการอนุมัติ
                                    </th>
                                </tr>

                                <tr>
                                    {budgetYears.map(year => (
                                        <th key={year} colSpan="3" className="text-center">
                                            ปีงบประมาณ {year}
                                        </th>
                                    ))}
                                </tr>

                                <tr>
                                    {budgetYears.map(year => (
                                        <React.Fragment key={year}>
                                            <th className="text-center">(แห่ง)</th>
                                            <th className="text-center">(คน)</th>
                                            <th className="text-center">(บาท)</th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {reportData.map((row, i) => {

                                    const percent = grandTotal > 0
                                        ? ((rowTotals[i] / grandTotal) * 100).toFixed(2)
                                        : "0.00";

                                    return (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td className="text-start">{row.supportTypeName}</td>

                                            {row.detailBudgetYear?.map((data, j) => (
                                                <React.Fragment key={j}>
                                                    <td className='text-end'>{NumberWithCommmas2(data.supportAmount)}</td>
                                                    <td className='text-end'>{NumberWithCommmas2(data.personAmount)}</td>
                                                    <td className='text-end'>{NumberWithCommmas2(data.amount)}</td>
                                                </React.Fragment>
                                            ))}

                                            <td className="text-end bg-light fw-bold">
                                                {percent}%
                                            </td>
                                        </tr>
                                    );
                                })}

                                {/* ===== รวมทั้งหมด ===== */}
                                <tr className="table-secondary fw-bold">
                                    <td colSpan="2" className="text-center">รวมทั้งหมด</td>

                                    {yearTotals.map((y, i) => (
                                        <React.Fragment key={i}>
                                            <td className="text-end">{NumberWithCommmas2(y.totalSupport)}</td>
                                            <td className="text-end">{NumberWithCommmas2(y.totalPerson)}</td>
                                            <td className="text-end">{NumberWithCommmas2(y.totalAmount)}</td>
                                        </React.Fragment>
                                    ))}

                                    <td className="text-end">100%</td>
                                </tr>

                            </tbody>

                        </Table>
                    </div>
                </div>

            </div>
        </Container>
    )
}